import bulkUploadEN from 'templates/bulk-upload/bulk-upload-en.xlsx';
import bulkUploadID from 'templates/bulk-upload/bulk-upload-id.xlsx';
import bulkUploadMS from 'templates/bulk-upload/bulk-upload-ms.xlsx';
import bulkUploadTH from 'templates/bulk-upload/bulk-upload-th.xlsx';
import bulkUploadVI from 'templates/bulk-upload/bulk-upload-vi.xlsx';

import bulkUploadV2EN from 'templates/bulk-upload/bulk-upload-v2-en.xlsx';
import bulkUploadV2ID from 'templates/bulk-upload/bulk-upload-v2-id.xlsx';
import bulkUploadV2MS from 'templates/bulk-upload/bulk-upload-v2-ms.xlsx';
import bulkUploadV2TH from 'templates/bulk-upload/bulk-upload-v2-th.xlsx';
import bulkUploadV2VI from 'templates/bulk-upload/bulk-upload-v2-vi.xlsx';

export const getExcelTemplateEnpoint = (locale = 'en') => {
  switch (locale) {
    case 'id':
      return bulkUploadID;
    case 'ms':
      return bulkUploadMS;
    case 'th':
      return bulkUploadTH;
    case 'vi':
      return bulkUploadVI;
    default:
      return bulkUploadEN;
  }
};

export const getExcelTemplateV2Endpoint = (locale = 'en') => {
  switch (locale) {
    case 'id':
      return bulkUploadV2ID;
    case 'ms':
      return bulkUploadV2MS;
    case 'th':
      return bulkUploadV2TH;
    case 'vi':
      return bulkUploadV2VI;
    default:
      return bulkUploadV2EN;
  }
};

export const getMetaDataEnpoint = ({ cityID }) => {
  const { endpoints: { geWebAPIBase } } = window.Grab.config;
  const urlSearchParams = new URLSearchParams({
    cityID,
  });
  return `${geWebAPIBase}/v3/bulkupload/template/meta?${urlSearchParams.toString()}`;
};

export const getClusteringEnpoint = () => {
  const { endpoints: { geWebAPIBase } } = window.Grab.config;
  return `${geWebAPIBase}/v2/clustering`;
};

export default {
  getExcelTemplateEnpoint,
  getExcelTemplateV2Endpoint,
};
